import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {slider} from './config/animations';
import {MessagingService} from './services/messaging.service';
import {SwPush, SwUpdate} from '@angular/service-worker';
import {BackendApi} from './config/backend-api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slider
    // animation triggers go here
  ]
})

export class AppComponent implements OnInit {
  title = 'IBDTool-fe';

  constructor(updates: SwUpdate, push: SwPush, private messagingService: MessagingService) {
    updates.available.subscribe(event => {
      updates.activateUpdate().then(() => {
        document.location.reload();
      });
    });
    push.messages.subscribe(() => {
      console.log('update');
    });

  }


  ngOnInit(): void {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    // Register your service worker:

    navigator.serviceWorker.ready.then((swRegistration) => {
      return swRegistration.sync.register('syncData');
    });
  }



  prepareRoute(outlet: RouterOutlet) {
    // @ts-ignore
    return outlet && outlet.activatedRouteData.depth;
  }
}
